import { render, staticRenderFns } from "./ShsSummary.vue?vue&type=template&id=f0d10452&scoped=true&"
import script from "./ShsSummary.vue?vue&type=script&lang=js&"
export * from "./ShsSummary.vue?vue&type=script&lang=js&"
import style0 from "./ShsSummary.vue?vue&type=style&index=0&id=f0d10452&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0d10452",
  null
  
)

export default component.exports